/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_TitleInputs */

const en_update_title = /** @type {(inputs: Update_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update ready.`)
};

const de_update_title = /** @type {(inputs: Update_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update bereit.`)
};

/**
* | output |
* | --- |
* | "Update ready." |
*
* @param {Update_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const update_title = /** @type {((inputs?: Update_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_update_title(inputs)
	return en_update_title(inputs)
});